import React from "react";

function Btn(props) {
    
    return (
        <div id="btn">
            <button style={props.Style} onClick={props.clicked}> {props.text} </button>
        </div>
    );
}
export default Btn;